import { Button } from "components";
import QuestionCard from "elements/QuestionCard";
import { usePropertyContext } from "../../context";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import ButtonV2 from "elements/ButtonV2";

const TransferringHomestead = () => {
	const { next, transferringHomesteadValue, setTransferringHomesteadValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Transfer_Question_Answer,
			data: {
				Transfer: transferringHomesteadValue ? "Yes" : "No",
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			Transfer: transferringHomesteadValue ? "Yes" : "No",
		};
		next({ trackingEventData });
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<QuestionCard
				id="transferhomestead"
				value={transferringHomesteadValue}
				setValue={setTransferringHomesteadValue}
				tooltipText=""
				question="Would you like to transfer the homestead exemption to this property?"></QuestionCard>
			{transferringHomesteadValue === false && (
				<p className="sm exemptions-notification-message-azure">
					You've indicated that you currently have a homestead exemption at
					another residence but you don't want to transfer it to{" "}
					<span className="no-translate">{details?.address}</span>. Since you
					can only have homestead on one property at a time, we can move on to
					see what other ways we can help you save!
				</p>
			)}
			<ButtonV2
				size="large"
				disabled={transferringHomesteadValue === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default TransferringHomestead;
